const BUILD_TIME_CONFIG_TYPES = {
    LANGUAGES: 'languages',
    CONFIG: 'config',
    PAGES: 'pages',
    APPLETS: 'applets',
    BLOCKS: 'blocks',
    COMPONENTS: 'components',
    SETTINGS: 'settings',
    BCS: 'bcs',
    DPS: 'dps',
    SCHEMA: 'schema',
    SYNCHRONIZATION: 'sync',
    AUTHORIZATION: 'auth',
    FIELD_VALIDATION: 'field-validation',
    JAVASCRIPT: 'javascript',
    STYLES: 'styles'
};

export default BUILD_TIME_CONFIG_TYPES;
